import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  animations: [
    trigger('slideDown', [
      transition('* => *', [
        style({ transform: 'translateY(-100%)' }),
        animate('600ms ease-in-out', style({ transform: 'translateY(0)' }))
      ])
    ]),

    trigger('slideLeft', [
      transition('* => *', [
        style({ transform: 'translateX(-150%)' }),
        animate('600ms 900ms ease-in-out', style({ transform: 'translateX(0)' }))
      ])
    ]),

    trigger('slideRight', [
      transition('* => *', [
        style({ transform: 'translateX(150%)' }),
        animate('600ms 900ms ease-in-out', style({ transform: 'translateX(0)' }))
      ])
    ])
  ]
})
export class MainHeaderComponent {
  @Input() name: string = '';  
  @Input() logo: string = '';
  @Input() logoHeight: string = '20px';
  @Output() clickMenu: EventEmitter<any> = new EventEmitter();
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/layout/main-header/main-header.component.ts